'use client';

import {
  ProductLicenseInfo,
  ProductLicenseResponse,
} from '@/features/games-app/shared/types/licensing.types';
import { getIpcClient } from '@/features/games-app/shared/client/ipc-client';

export async function getProductLicenceInformation(
  sku: string,
): Promise<ProductLicenseInfo | undefined> {
  const ipcClient = getIpcClient();

  const response = await ipcClient.send<ProductLicenseResponse>({
    name: 'productcatalog',
    action: 'getproductlicenseinfo',
    body: { productId: sku },
  });

  return response.productlicensing;
}
